import { ELEMENT_MODULE_PATHS, ELEMENT_MODULE_PATHS_AS_ROUTES } from './element-registry';
var ɵ0 = ELEMENT_MODULE_PATHS, ɵ1 = ELEMENT_MODULE_PATHS_AS_ROUTES;
var CustomElementsModule = /** @class */ (function () {
    function CustomElementsModule() {
    }
    return CustomElementsModule;
}());
export { CustomElementsModule };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/custom-elements/custom-elements.module.ts.pre-build-optimizer.js